import { render } from "./Declaration.vue?vue&type=template&id=407e51f7&scoped=true"
import script from "./Declaration.vue?vue&type=script&lang=js"
export * from "./Declaration.vue?vue&type=script&lang=js"

import "./Declaration.vue?vue&type=style&index=0&id=407e51f7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407e51f7"]])

export default __exports__